import React from "react";
import { Tag } from "antd";
import { Check, Warning, Error, Information } from "assets/icons";
import theme from "styles/theme";
import * as S from "./styled/index.styled";

interface IVehicleStatusIcon {
  vehicleStatus: number;
  title: string;
}

const VehicleStatusIcon = ({ vehicleStatus, title }: IVehicleStatusIcon): JSX.Element => {
  const notMapped = 0;
  const success = 1;
  const unauthorized = 2;
  const error = 3;
  const info = 4;

  const TagStatus = (icon, colorStatus, colorText, dataTestId) => (
    <S.TagIcon>
      <Tag className="vehicleStatusIcon" style={{ color: colorText }} icon={icon} color={colorStatus} data-testid={dataTestId}>
        {title}
      </Tag>
    </S.TagIcon>
  );

  return (
    <div>
      {vehicleStatus === notMapped && <></>}
      {vehicleStatus === success && TagStatus(<Check />, theme["@color-positive-100"], theme["@color-positive-600"], "success")}
      {vehicleStatus === unauthorized && TagStatus(<Warning />, theme["@color-warning-100"], theme["@color-warning-600"], "unauthorized")}
      {vehicleStatus === error && TagStatus(<Error />, theme["@color-danger-100"], theme["@color-danger-600"], "error")}
      {vehicleStatus === info && TagStatus(<Information />, theme["@muted-background"], theme["@profile-text-color"], "information")}
    </div>
  );
};

export default VehicleStatusIcon;
